.title {
  margin-top: 0;
}

.avatarRow {
  margin-bottom: 24px;
}

.narrowForm {
  max-width: 480px;
}
